<template>
    <ClientOnly>
        <TranslateButton v-if="isTranslationActivated && hasDescription" section="about" />
        <template #fallback>
            <SectionActionSkeleton />
        </template>
    </ClientOnly>
</template>
<script setup lang="ts">
    import {computed, onMounted, onUnmounted} from 'vue';
    import {storeToRefs} from 'pinia';
    import TranslateButton from '~/components/main/TranslateButton.vue';
    import SectionActionSkeleton from '~/components/section/SectionActionSkeleton.vue';
    import {eventBus} from '~/config/events';
    import {useProfileStore} from '~/store/profileStore';
    import {TranslationDirection, useTranslationStore} from '~/store/translation/translationStore';

    const translationSection = 'profile';
    const translationField = 'description';

    const {profile} = storeToRefs(useProfileStore());
    const {isTranslationActivated} = storeToRefs(useTranslationStore());
    const {translateAll, replaceTranslationContent} = useTranslationStore();

    const hasDescription = computed(() => (profile.value?.description?.length ?? 0) > 0);

    onMounted(() => {
        eventBus.on('translation:request', translateAboutDescription);
        eventBus.on('translation:restore', restoreAboutDescription);
    });

    onUnmounted(() => {
        eventBus.off('translation:request', translateAboutDescription);
        eventBus.off('translation:restore', restoreAboutDescription);
    });

    async function translateAboutDescription() {
        const descriptionRequest = {
            section: translationSection,
            field: translationField,
            index: 0,
            originalContent: profile.value?.description ?? ' ',
        };

        await translateAll([descriptionRequest]);
        replaceTranslationContent(translationSection, translationField, TranslationDirection.TRANSLATE, switchTranslation);
    }

    function restoreAboutDescription() {
        replaceTranslationContent(translationSection, translationField, TranslationDirection.RESTORE, switchTranslation);
    }

    function switchTranslation(content: string) {
        if (profile.value) {
            profile.value.description = content;
        }
    }
</script>
